// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 此处后端没有提供注释 POST /user/admin/login */
export async function adminLogin(
  body: API.LoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.RLoginVO>("/user/admin/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/alipay/login */
export async function alipayLogin(
  body: API.AlipayLoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.RAlipayVO>("/user/alipay/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/detail */
export async function getUserOrder(
  body: API.UserOrderQueryRequest,
  options?: { [key: string]: any }
) {
  return request<API.RPageUserOrderVO>("/user/detail", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/get/all */
export async function getAllUser(
  body: API.UserQueryRequest,
  options?: { [key: string]: any }
) {
  return request<API.RPageUser>("/user/get/all", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /user/get/login */
export async function getLogin(options?: { [key: string]: any }) {
  return request<API.RLoginVO>("/user/get/login", {
    method: "GET",
    ...(options || {}),
  });
}

/** 导出用户列表 GET /user/export */
export async function exportUsers(options?: { [key: string]: any }) {
  return request<Blob>("/user/export", {
    method: "GET",
    responseType: 'blob', // 关键：指定响应类型为blob
    getResponse: true,    // 获取完整的响应对象
    ...(options || {}),
  }).then(response => {
    return response as any; // 返回完整的响应
  });
}

/** 此处后端没有提供注释 GET /user/logout */
export async function adminLogout(options?: { [key: string]: any }) {
  return request<API.RBoolean>("/user/logout", {
    method: "GET",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/update */
export async function adminUpdate(
  body: API.User,
  options?: { [key: string]: any }
) {
  return request<API.RBoolean>("/user/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/wechat/login */
export async function wechatLogin(
  body: API.WechatLoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.RAlipayVO>("/user/wechat/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
